import UserSessionDetail from './user-session.details';

export const UserSessionStore = {
  detail: UserSessionDetail,
};
